import React from 'react';

const ErrorMessage = ({ 
  error, 
  onRetry, 
  title = 'Something went wrong',
  showRetry = true 
}) => {
  if (!error) return null;

  return (
    <div style={{
      background: '#fef2f2',
      border: '1px solid #fecaca',
      borderRadius: 8,
      padding: 16,
      margin: '16px 0',
      textAlign: 'center'
    }}>
      <div style={{
        color: '#dc2626',
        fontWeight: 600,
        fontSize: '1rem',
        marginBottom: 8
      }}>
        {title}
      </div>
      <div style={{
        color: '#7f1d1d',
        fontSize: '0.875rem',
        marginBottom: showRetry ? 12 : 0
      }}>
        {error}
      </div>
      {showRetry && onRetry && (
        <button
          onClick={onRetry}
          className="ffb-btn"
          style={{ background: '#dc2626' }}
        >
          Try Again
        </button>
      )}
    </div>
  );
};

export default ErrorMessage; 